module.exports = __webpack_public_path__ + "img/bg_order_confirmation2.4f834170.gif";